import React from "react";

import { I18nextLocale } from "@/types/types";

import { MultiSwitch } from "./MultiSwitch";
import { useLanguageSwitch } from "./useLanguageSwitch";

export type LanguageSwitchProps = {
  theme?: "light" | "dark";
  className?: string;
};

export const LanguageSwitch = ({
  theme = "light",
  className,
}: LanguageSwitchProps) => {
  const { locale, handleLanguageChange } = useLanguageSwitch();

  const languages = [
    {
      id: I18nextLocale.NO_NO,
      label: "Norsk",
    },
    {
      id: I18nextLocale.EN_NO,
      label: "English",
    },
  ];

  return (
    <MultiSwitch
      theme={theme}
      className={className}
      onChange={handleLanguageChange}
      activeId={locale}
      elems={languages}
    />
  );
};
